import { Card, CardContent } from '@mui/material'
import styled from 'styled-components'
import { CommonColorCodes } from '../../utility/CommonColorCodes'
import { useNavigate } from 'react-router-dom'
import { BaseUrl as getBlobBaseUrl } from '../../utility/BaseUrl'
import React, { useContext } from 'react'
import { AppContext } from '../../App'
import { isValidJson } from '../../utility/Utility'
import { AppTitle, AppDescription, IconWrapper } from '../../css/Style'

const AppCardsContainer = styled.div`
padding-bottom : 20px;
display: inline-flex;
flex-wrap: wrap;
justify-content: flex-start;
width: 895px;
@media (min-width: 0px) and (max-width: 1350px) {
    flex-direction: row;
    justify-content: flex-start;
    width :100%
};
`

const CardIcon = styled.div`
`

const AppTags = styled.div`
color: ${CommonColorCodes.PRIMARY_4};
position: absolute;
bottom: 5px;
margin-left: 15px;
overflow: hidden;
text-overflow: ellipsis;
width : 90%;
white-space: nowrap;
padding-bottom: 17.5px;
font-size: 12px;
font-family: 'AeonikPro-Medium'
`

interface Apps {
    appId: string;
    name: string;
    description: string;
    useCaseList: string[];
    categoryList: string[];
    applicationList: string[];
    icon: string;
}

interface AppCardsProps {
  apps: Apps[];
}

const AppCards: React.FunctionComponent<AppCardsProps> = (
  {
    apps
  }
) => {
  const { setCurrentApp } = useContext(AppContext)
  const navigate = useNavigate()
  const handleNav = (appId:string) => {
    setCurrentApp(appId)
    navigate('/details/' + appId)
  }

  const getAppIcon = (icon: string) => {
    if (icon) {
      icon = icon && isValidJson(icon) ? JSON.parse(icon).path : icon
      return <IconWrapper src= {`https://${getBlobBaseUrl()}${icon}`} />
    }
  }

  return (
        <AppCardsContainer>
            {
                apps.map((app, index) => {
                  return <Card key = {app.appId}
                        sx={{
                          width: '285px',
                          height: '252px',
                          backgroundColor: '#FFFFFF',
                          border: '1px solid #DCDFEC',
                          'border-radius': '8px',
                          'margin-top': '20px',
                          cursor: 'pointer',
                          'box-shadow': 'none',
                          marginRight: (index + 1) % 3 === 0 ? '1px' : '15px',
                          position: 'relative',
                          '@media (min-width: 0px) and (max-width: 450px)': {
                            width: '95%',
                            marginRight: '5px'
                          },
                          '@media (min-width: 451px) and (max-width: 1350px)': {
                            marginRight: '19px'
                          },
                          ':hover': { boxShadow: '0px 0px 12px rgba(115, 115, 115, 0.25)' }

                        }}
                    onClick={() => { handleNav(app.appId) }}
                    >
                        <CardContent>
                            <CardIcon>
                            {app.icon && getAppIcon(app.icon)}
                                {(!app.icon || app.icon === '') && <svg width="31" height="42" viewBox="0 0 31 42" fill="none"><mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="42"><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L19.2606 0.600744Z" fill="white"></path></mask><g mask="url(#mask0)"><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L23.883 7.09141L19.2606 0.600744Z" fill="#0F9D58"></path></g><mask id="mask1" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="42"><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L19.2606 0.600744Z" fill="white"></path></mask><g mask="url(#mask1)"><path d="M8.16699 20.5364V33.9813H22.9587V20.5364H8.16699ZM14.6383 32.1269H10.016V29.8088H14.6383V32.1269ZM14.6383 28.4179H10.016V26.0998H14.6383V28.4179ZM14.6383 24.7089H10.016V22.3909H14.6383V24.7089ZM21.1097 32.1269H16.4873V29.8088H21.1097V32.1269ZM21.1097 28.4179H16.4873V26.0998H21.1097V28.4179ZM21.1097 24.7089H16.4873V22.3909H21.1097V24.7089Z" fill="#F1F1F1"></path></g><mask id="mask2" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="42"><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L19.2606 0.600744Z" fill="white"></path></mask><g mask="url(#mask2)"><path d="M20.0718 10.914L30.3543 21.2249V11.7276L20.0718 10.914Z" fill="url(#paint0_linear)"></path></g><mask id="mask3" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="42"><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L19.2606 0.600744Z" fill="white"></path></mask><g mask="url(#mask3)"><rect x="17.4116" y="-1.25372" width="16.6406" height="16.7459" fill="url(#pattern0)"></rect><path d="M19.2607 0.600744V8.94589C19.2607 10.4828 20.5019 11.7276 22.0342 11.7276H30.3545L19.2607 0.600744Z" fill="#87CEAC"></path></g><mask id="mask4" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="42"><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L19.2606 0.600744Z" fill="white"></path></mask><g mask="url(#mask4)"><path d="M3.54443 0.600744C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V3.61427C0.770996 2.08433 2.01904 0.832554 3.54443 0.832554H19.2606V0.600744H3.54443Z" fill="white" fillOpacity="0.2"></path></g><mask id="mask5" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="42"><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L19.2606 0.600744Z" fill="white"></path></mask><g mask="url(#mask5)"><path d="M27.5809 41.1674H3.54443C2.01904 41.1674 0.770996 39.9157 0.770996 38.3857V38.6175C0.770996 40.1475 2.01904 41.3993 3.54443 41.3993H27.5809C29.1063 41.3993 30.3543 40.1475 30.3543 38.6175V38.3857C30.3543 39.9157 29.1063 41.1674 27.5809 41.1674Z" fill="#263238" fillOpacity="0.2"></path></g><mask id="mask6" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="42"><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L19.2606 0.600744Z" fill="white"></path></mask><g mask="url(#mask6)"><path d="M22.0342 11.7276C20.5019 11.7276 19.2607 10.4828 19.2607 8.94589V9.1777C19.2607 10.7146 20.5019 11.9594 22.0342 11.9594H30.3545V11.7276H22.0342Z" fill="#263238" fillOpacity="0.1"></path></g><path d="M19.2606 0.600744H3.54443C2.01904 0.600744 0.770996 1.85252 0.770996 3.38246V38.6175C0.770996 40.1475 2.01904 41.3992 3.54443 41.3992H27.5809C29.1063 41.3992 30.3543 40.1475 30.3543 38.6175V11.7276L19.2606 0.600744Z" fill="url(#paint1_radial)"></path></svg>}
                            </CardIcon>
                            <AppTitle>
                              {app.name}
                            </AppTitle>
                            <AppDescription>
                                {app.description}
                            </AppDescription>
                        </CardContent>
                        <AppTags>{app.useCaseList && app.useCaseList.length > 0 ? app.useCaseList.join(', ') : ''}</AppTags>
                    </Card>
                })
            }
        </AppCardsContainer>
  )
}

export default AppCards
